import { styled } from "@material-ui/styles";
import Box from "@material-ui/core/Box";

export default styled(Box)({
  fontWeight: 600,
  fontSize: "16px",
  lineHeight: "150%",
});
